import type { FC, ReactNode } from "react";

interface FormMessageProps {
  type: "error" | "success" | "warning";
  children: ReactNode;
}

/**
 * Shared form message component for errors, success, and warnings
 * Matches Issue Integration design patterns
 */
export const FormMessage: FC<FormMessageProps> = ({ type, children }) => {
  const typeClasses = {
    error:
      "border-rose-300 bg-rose-50 text-rose-700 dark:border-rose-500/40 dark:bg-rose-500/10 dark:text-rose-100",
    success:
      "border-emerald-300 bg-emerald-50 text-emerald-700 dark:border-emerald-500/40 dark:bg-emerald-500/10 dark:text-emerald-100",
    warning:
      "border-amber-300 bg-amber-50 text-amber-700 dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-100",
  };

  return (
    <div
      className={`rounded-none border px-3 py-2 text-xs ${typeClasses[type]}`}
    >
      {children}
    </div>
  );
};
